<template>
    <el-container v-loading.fullscreen.lock="fullscreenLoading" :element-loading-text=" $t('home.loading')"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.5)">
        <div class="home" id="container" v-if="!fullscreenLoading">
            <TopBar @search="showSearchResult(arguments)"></TopBar>
            <TopBarSecond v-if="content.content.length === 0"></TopBarSecond>

            <div id="content-area" :style="{marginTop: content.content.length === 0 ? '30px': '70px'}">
                <div class="float-help-area"></div>
                <div class="float-help-menu" @mouseenter="showHelpInfo" @mouseleave="hideHelpInfo">
                    <img :src="getImageSrc" mode="widthFix" class="call4help"/>
                </div>
                <transition name="fade">
                    <div class="help_info_area" v-show="showHelp">
                        <span style="font-weight: bold;font-size: 18px">{{$t('home.contact_one')}}</span>
                        <span style="line-height: 22px;font-size: 17px">{{$t('home.call_number')}}</span>
                        <span style="line-height: 20px;font-size: 15px">{{$t('home.contact_two')}}</span>
                    </div>
                </transition>

                <div class="menu-area" id="sideMenu" :style="{height: menuHeight + 'px'}">
                    <SideMenu :allMenuList="allMenuList" :activeIndex="activeIndex" @refresh="getContent"
                              ref="sideMenu"></SideMenu>
                </div>
                <div id="homeMain" v-if="content.content.length > 0">
                    <!--<HomeMainTopBar></HomeMainTopBar>-->
                    <span style="font-weight: bold;color: #333;font-size: 32px;margin-top: 10px;">{{content.title}}</span>
                    <span style="font-size: 12px; color: #888;margin-top: 10px;">{{$t('home.last_update')}}{{content.gmtCreate}}</span>
                    <div id="mainContent" v-html="content.content"></div>
                </div>
                <div id="homeOverview" v-else>
                    <template v-for="menu in allMenuList">
                        <NavMenu :menu="menu" @refresh="getContent"></NavMenu>
                    </template>
                </div>
            </div>
        </div>
    </el-container>
</template>
<script>
    import TopBar from "@/components/TopBar.vue";
    import TopBarSecond from "@/components/TopBarSecond.vue";
    import HomeMainTopBar from "@/components/HomeMainTopBar.vue";
    import SideMenu from "@/components/SideMenu.vue";
    import NavMenu from "@/components/NavMenu.vue";

    var _this

    export default {
        name: "home",
        components: {
            HomeMainTopBar,
            TopBar,
            TopBarSecond,
            SideMenu,
            NavMenu
        },
        data() {
            return {
                showHelp: false,
                allMenuList: [],
                content: {
                    title: '',
                    gmtCreate: '',
                    content: ''
                },
                searchKey: '',
                activeIndex: '',
                menuHeight: 500,
                fullscreenLoading: false,
                lang: 1,
                localeInUrl:'zh',
                contactImg:''
            }
        },
        computed: {
            getImageSrc() {
                if (localStorage.getItem('locale') === 'en') {
                    return require('@/assets/contact_big_en.png');
                } else if (localStorage.getItem('locale') === 'tc') {
                    return require('@/assets/contact_big_ft.png');
                } else {
                    return require('@/assets/contact.png');
                }
            }
        },
        filters: {},
        watch: {
            $route(to, from) {
                if (to.path === '/') {
                    document.documentElement.scrollTop = 0
                    this.activeIndex = to.path.split("/")[1]
                    this.$router.go(0)//页面刷新
                } else {
                    this.activeIndex = to.path.split("/")[1]
                    this.init(this.activeIndex.split("_"))
                }
            }
        },
        methods: {
            toggleLang(lang) {
                if (lang == 'zh') {
                    localStorage.setItem('locale', 'zh')
                    this.$i18n.locale = localStorage.getItem('locale')
                    window.document.title = "小飞鼠RPA帮助中心"
                    this.lang = 1
                } else if (lang == 'en') {
                    localStorage.setItem('locale', 'en')
                    this.$i18n.locale = localStorage.getItem('locale')
                    window.document.title = "RPA Help Center"
                    this.lang = 3
                } else if (lang == 'tc') {
                    localStorage.setItem('locale', 'tc')
                    this.$i18n.locale = localStorage.getItem('locale')
                    window.document.title = "小飛鼠RPA幫助中心"
                    this.lang = 2
                }
                this.$nextTick(()=>{
                    this.init(this.activeIndex.split("_"))
                })
            },
            showHelpInfo() {
                this.showHelp = true
            },
            hideHelpInfo() {
                this.showHelp = false
            },
            showSearchResult(params) {
                // console.log("showSearchResult")
                // console.log(params)
                this.activeIndex = params[0]

                // console.log("activeIndex is " + this.activeIndex)
                this.searchKey = params[1]
                if (!this.$route.path.endsWith(params[0])) {
                    this.$router.push("/" + params[0])
                } else {
                    if (this.searchKey.length > 0) {
                        // console.log("scrollToLocation")
                        this.scrollToLocation();
                    }
                }
                this.$refs.sideMenu.openMenu(this.activeIndex)
            },

            getContent() {
                let index = ""
                if (this.$store.state.sideInfo.menu) {
                    index += this.$store.state.sideInfo.menu.id
                }
                if (this.$store.state.sideInfo.submenu) {
                    index += "_" + this.$store.state.sideInfo.submenu.id
                }
                if (this.$store.state.sideInfo.article) {
                    index += "_" + this.$store.state.sideInfo.article.id
                }
                // if (index.length == 0) {
                //     return
                // }
                console.log("getContent " + index)
                // console.log("emit index " + val)

                if (!this.$route.path.endsWith("" + index)) {
                    this.$router.push("/" + index)
                }
                this.activeIndex = index

                if (index.split("_").length === 2) {
                    this.$get(this.$uri.subMenu.content, {menuId: this.$store.state.sideInfo.submenu.id, lang: this.lang}).then(res => {
                        if (res.success && res.data.content.length > 0) {
                            // console.log("searchKey " + this.searchKey)
                            this.content = res.data
                            switch(this.lang) {
                                case 2:
                                    this.content.title = res.data.titleTc
                                    break
                                case 3:
                                    this.content.title = res.data.titleEn
                                    break
                                default:
                                    this.content.title = res.data.title
                                    break
                            }
                            // console.log(res.data)
                            if (this.searchKey.length > 0) {
                                this.scrollToLocation();
                            } else {
                                document.documentElement.scrollTop = 0
                            }
                        }
                    }).finally(() => {
                        this.fullscreenLoading = false
                    })
                } else if (index.split("_").length === 3) {
                    // this.content = {
                    //     title: '',
                    //     gmtCreate: '',
                    //     content: ''
                    // }
                    this.$get(this.$uri.article.content, {articleId: this.$store.state.sideInfo.article.id, lang: this.lang}).then(res => {
                        if (res.success && res.data.content.length > 0) {
                            this.content = res.data
                            switch(this.lang) {
                                case 2:
                                    this.content.title = res.data.titleTc
                                    break
                                case 3:
                                    this.content.title = res.data.titleEn
                                    break
                                default:
                                    this.content.title = res.data.title
                                    break
                            }
                            if (this.searchKey.length > 0) {
                                this.scrollToLocation();
                            }
                            else {
                                document.documentElement.scrollTop = 0
                            }
                        }
                    }).finally(() => {
                        this.fullscreenLoading = false
                    })
                } else {
                    this.fullscreenLoading = false
                }
            },
            scrollToLocation() {
                setTimeout(() => {
                    var pArr = document.getElementById("mainContent").getElementsByTagName("span")
                    // console.log(pArr[0])
                    if (pArr.length > 0) {
                        // let regExp = new RegExp(this.searchKey, "g");
                        for (let pItem of pArr) {
                            if (pItem.innerHTML.indexOf(this.searchKey) !== -1 && pItem.innerHTML.indexOf("<img") === -1 && pItem.innerHTML.indexOf("<video") === -1) {
                                window.scrollTo({
                                    top:
                                    pItem.offsetTop - 50,
                                    behavior: "smooth",
                                });
                                break;
                            }
                        }
                    }
                }, 50);
            }
            ,
            init(idArr) {
                // console.log("idArr is " + JSON.stringify(idArr))
                this.$post(this.$uri.menu.listAll).then(res => {
                    // console.log("res is " + JSON.stringify(res))
                    if (res && res.success) {
                        // console.log("allMenuListInfo is " + JSON.stringify(res))
                        this.allMenuList = res.data
                        let sideInfo = {}
                        if (idArr.length === 1) {
                            this.allMenuList.forEach(menu => {
                                if (menu.id == idArr[0]) {
                                    if (i18n.locale == 'en' && menu.titleEn || i18n.locale == 'tc' && menu.titleTc || i18n.locale == 'zh' && menu.title) {
                                        sideInfo.menu = menu
                                    }
                                }
                            })
                        }
                        else if (idArr.length === 2) {
                            this.allMenuList.forEach(menu => {
                                // console.log("menu is " + JSON.stringify(menu))
                                if (menu.id == idArr[0]) {
                                    if (i18n.locale == 'en' && menu.titleEn || i18n.locale == 'tc' && menu.titleTc || i18n.locale == 'zh' && menu.title) {
                                        sideInfo.menu = menu
                                    }
                                    menu.menuLevelTwoList.forEach(subMenu => {
                                        if (subMenu.id == idArr[1]) {
                                            if (i18n.locale == 'en' && subMenu.titleEn || i18n.locale == 'tc' && subMenu.titleTc || i18n.locale == 'zh' && subMenu.title) {
                                                sideInfo.submenu = subMenu
                                            }
                                        }
                                    })
                                }
                            })
                        } else if (idArr.length === 3) {
                            this.allMenuList.forEach(menu => {
                                if (menu.id == idArr[0]) {
                                    if (i18n.locale == 'en' && menu.titleEn || i18n.locale == 'tc' && menu.titleTc || i18n.locale == 'zh' && menu.title) {
                                        sideInfo.menu = menu
                                    }
                                    menu.menuLevelTwoList.forEach(subMenu => {
                                        if (subMenu.id == idArr[1]) {
                                            if (i18n.locale == 'en' && subMenu.titleEn || i18n.locale == 'tc' && subMenu.titleTc || i18n.locale == 'zh' && subMenu.title) {
                                                sideInfo.submenu = subMenu
                                            }
                                            subMenu.articleList.forEach(article => {
                                                if (article.id == idArr[2]) {
                                                    if (i18n.locale == 'en' && article.titleEn || i18n.locale == 'tc' && article.titleTc || i18n.locale == 'zh' && article.title ) {
                                                        sideInfo.article = article
                                                    }
                                                }
                                            })
                                        }
                                    })
                                }
                            })
                        }
                        this.$store.commit(this.$mutation.SIDE_INFO, sideInfo)
                        this.getContent()
                    }
                })
            }
        }
        ,
        beforeMount() {
            this.fullscreenLoading = true
            let url = window.location.href
            this.activeIndex = url.split("/")[url.split("/").length - 1].split("?")[0]
            var locale = url.split("/")[url.split("/").length - 1].split("?")[1]
            if (locale) {
                this.localeInUrl = locale.split('=')[1]
                this.toggleLang(this.localeInUrl)
            }

            this.$store.commit(this.$mutation.SIDE_INFO, {})
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight
            this.menuHeight = windowHeight - 80
        },
        beforeRouteLeave() {

        },
        mounted() {
            console.log("activeIndex is " + this.activeIndex)
            console.log("locale in storage is " + localStorage.getItem('locale'))
            if (localStorage.getItem('locale') == 'en') {
                this.lang = 3
            } else if (localStorage.getItem('locale') == 'tc') {
                this.lang = 2
            } else {
                this.lang = 1
            }
            // console.log("this.localeInUrl is " + this.localeInUrl)
            this.init(this.activeIndex.split("_"))
            _this = this
            window.addEventListener('scroll', function () {
                if (_this.content.content.length > 0) {
                    let navBar = document.querySelector('#sideMenu')
                    // 获取导航条的高度，因为后期内容面板的margin-top需要以这个值做为参照
                    let navBarTop = navBar.offsetTop - 50
                    // 获取当前滚动出屏幕的距离
                    let offset = document.documentElement.scrollTop
                    let homeMain = document.querySelector('#homeMain')
                    // 判断卷出屏幕的距离是否大于导航条离顶部的距离
                    if (offset >= navBarTop) {
                        if (navBar) {
                            navBar.classList.add('fixed')
                        }
                        if (homeMain) {
                            homeMain.classList.add('home-main-fixed')
                        }
                    } else {
                        if (navBar) {
                            navBar.classList.remove('fixed')
                        }
                        if (homeMain) {
                            homeMain.classList.remove('home-main-fixed')
                        }
                    }
                }
            })
        }
    }
</script>

<style scoped lang="less">
    * {
        margin: 0;
        padding: 0;
        --height: 120px;
    }

    .home {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;

        #homeMain {
            padding: 0 30px;
            overflow-y: scroll;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        }
        #homeOverview {
            width: 100%;
            height: auto;
            padding: 0 30px;
            overflow-y: scroll;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        }
    }

    .menu-area {
        width: 230px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    }

    .fixed {
        position: fixed;
        width: 230px;
        left: 0;
        top: 50px;
    }

    .home-main-fixed {
        margin-left: 230px;
    }

    .home-overview-fixed {
        margin-left: 230px;
    }

    #content-area {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
    }
    .float-help-area{
        width: 10px;
        height: var(--height);
        position: fixed;
        bottom: 50px;
        right: 0;
        background-color: white;
        z-index:2;
    }
    .float-help-menu {
        width: 46px;
        height: var(--height);
        position: fixed;
        bottom: 50px;
        right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 3;
        transition: all .8s ease-in-out;
        background-size: 200% 100%;
        background-position: left bottom;
        background-image: linear-gradient(to right, #3e67ff 50%, #5181FF 50%);
    }
    .float-help-menu:hover {
        color: #3e67ff;
        background-position: right bottom;
    }

    .call4help {
        width: 41px;
        height: 116px;
    }

    .help_info_area {
        position: fixed;
        bottom: 50px;
        right: 56px;
        width: 180px;
        height: var(--height);
        border-right: 1px solid white;
        background-color: #3e67ff;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        span {
            line-height: 32px;
            color: white;
        }
    }

    .fade-enter, .fade-leave-to {
        transform: translateX(180px);
    }

    .fade-enter-active, .fade-leave-active {
        transition: all .8s ease-in-out;
    }

    .fade-enter-to, .fade-leave {
        transform: translateX(0);
    }
</style>
